import { render, staticRenderFns } from "./eventNotification.vue?vue&type=template&id=9160396c&scoped=true&"
import script from "./eventNotification.vue?vue&type=script&lang=js&"
export * from "./eventNotification.vue?vue&type=script&lang=js&"
import style0 from "./eventNotification.vue?vue&type=style&index=0&id=9160396c&lang=scss&scoped=true&"
import style1 from "./eventNotification.vue?vue&type=style&index=1&id=9160396c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9160396c",
  null
  
)

export default component.exports